module.exports = __webpack_public_path__ + "static/media/970-x-90.a546785a.svg";